import { createSlice} from '@reduxjs/toolkit';
import { RootState } from '..';

export interface subBooking {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: subBooking = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const subBookingSlice = createSlice({
  name: 'subBooking',
  initialState,
  reducers: {
    setSubBooking: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setSubBooking, reset } = subBookingSlice.actions;

export const addsubBooking = (state: RootState) => state.subBooking.data;
export const getsubBookingTotalRecord = (state: RootState) => state.subBooking.totalRecords;
export default subBookingSlice.reducer;
